import React, { useEffect, useState } from 'react'

import {
  message, Modal, Upload, Spin,
} from 'antd'

import Cookies from 'js-cookie'

import { PlusOutlined } from '@ant-design/icons'

import { fetch } from '../../utils/fetch'

const UploadImage = ({
  editData, typeId, action, orderId, headerId, itemId,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [previewImage, setPreviewImage] = useState('')
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewTitle, setPreviewTitle] = useState('')
  const [imageList, setImageList] = useState([])

  const endpoint = process.env[`REACT_APP_ENDPOINT_${process.env.REACT_APP_ENV}`]
  const headers = { Authorization: Cookies.get(`oms-token-${process.env.REACT_APP_ENV}`) }
  const actionUrl = (action !== undefined) && (action !== null) && (action === 'Header')
    ? `${endpoint}/order/${orderId}/image/header/${headerId}`
    : `${endpoint}/order/${orderId}/image/item/${itemId}`

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  )

  const getBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!')
    }
    const isLt2M = file.size / 1024 / 1024 / 1024 / 1024
    / 1024 / 1024 / 1024 / 1024 / 1024 / 1024 < 10
    if (!isLt2M) {
      message.error('Image must smaller than 10MB!')
    }
    return isJpgOrPng && isLt2M
  }

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) { file.preview = await getBase64(file.originFileObj) }
    setPreviewImage(file.url || file.preview)
    setPreviewVisible(true)
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1))
  }

  const handleChange = async (info) => {
    const newFileList = await info?.fileList
    setImageList(newFileList)
  }

  const handleCancel = () => {
    setPreviewVisible(false)
  }

  const handleRemove = (file) => {
    setIsLoading(true)
    const headerImageId = file?.orderHeaderImageId ? file?.orderHeaderImageId
      : file?.response?.data?.orderHeaderImageId
    const itemImageId = file?.orderItemImageId ? file?.orderItemImageId
      : file?.response?.data?.orderItemImageId
    const apiUrl = (action !== undefined) && (action !== null) && (action === 'Header')
      ? `/order/${orderId}/image/header/${headerId}/${headerImageId}`
      : `/order/${orderId}/image/item/${itemId}/${itemImageId}`
    fetch({
      method: 'DELETE',
      url: `${apiUrl}`,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res?.data?.success) {
        message.success('Image has been removed.')
      } else {
        console.log('Error:', res.data)
        message.error(res?.data?.message)
      }
      setIsLoading(false)
    })
  }

  useEffect(() => {
    if (editData) {
      setImageList(editData)
    } else {
      setImageList([])
    }
  }, [editData])

  return (
    <>
      <Spin spinning={isLoading} tip="Loading...">
        <Upload
          multiple
          name="attachment"
          listType="picture-card"
          onPreview={handlePreview}
          beforeUpload={beforeUpload}
          onChange={handleChange}
          onRemove={handleRemove}
          fileList={imageList}
          action={actionUrl}
          headers={headers}
          data={{ imageTypeId: typeId }}
        >
          {uploadButton}
        </Upload>
        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={handleCancel}
        >
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </Spin>
    </>
  )
}

export default UploadImage
